import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import CreateRepository from '../Repositories/CreateRepository'


class CreateBloc {

    createChannel = new Subject();
    flexyTimeChannel = new Subject();
    locationChannel = new Subject();
    repository = new CreateRepository()

    constructor() {
        this.createChannel.next({status: apiResponse.INITIAL})
        this.flexyTimeChannel.next({status: apiResponse.INITIAL})
        this.locationChannel.next({status: apiResponse.INITIAL})
    }

    fetchCreate = async (query) => {
        try {
            this.createChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchCreate(query).then((result) => {
                this.createChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.createChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchFlexytime = async (query) => {
        try {
            this.flexyTimeChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchFlexytime(query).then((result) => {
                this.flexyTimeChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.flexyTimeChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }

    fetchLocation = async (query) => {
        try {
            this.locationChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchLocation(query).then((result) => {
                this.locationChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.locationChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('unsubscribe')
        }
    }
}

export default CreateBloc